import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import { Link } from 'react-router-dom';
import './NavMenu.css';


export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.toggleAdmin = this.toggleAdmin.bind(this);

        this.state = {
            collapsed: true,
            collapsedAdmin: true,
            isAuth: false
        };

        this.renderAdminMenu = this.renderAdminMenu.bind(this);
    }

    componentDidMount() {
        this.props.firebase.auth.onAuthStateChanged((user) => {
            if (user) {
                this.setState({ isAuth: true });
            } else {
                this.setState({ isAuth: false });
            }
        });
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    toggleAdmin() {
        this.setState({
            collapsedAdmin: !this.state.collapsedAdmin
        });
    }

    logout() {
        this.props.firebase.auth.signOut();
    };

    renderLogin = () => {
        if (!this.state.isAuth)
            return (
                <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/login">Login</NavLink>
                </NavItem>
            );
        else
            return '';

    };

    renderAdminMenu() {

        if (this.state.isAuth)

            return (
                <Dropdown isOpen={!this.state.collapsedAdmin} toggle={this.toggleAdmin}>
                    <DropdownToggle caret>
                        Admin
                </DropdownToggle>
                    <DropdownMenu>
                        
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/product-adm">Productos</NavLink>
                        </DropdownItem>
                        

                        <DropdownItem onClick={() => this.logout()} >
                            <NavLink tag={Link} className="text-dark" to="/">Logout</NavLink>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            );
        else
            return '';
    }


    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/"> <img src="/StaticFiles/Logos/mil-guantes.png" width="100px" height="100px" alt="Logo" ></img> </NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/contactus">Nosotros</NavLink>
                                </NavItem>

                                
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/products">Productos</NavLink>
                                </NavItem>

                                

                                {this.renderLogin()}
                                {this.renderAdminMenu()}
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header >
        );
    }
}